import type { RegistrationDetails } from '../api/types'

/** The ANWB Koerslijst values a car from its kenteken and current mileage, in the reader's browser. */
export const KOERSLIJST_URL = 'https://www.anwb.nl/auto/koerslijst'

/** The ANWB Koerslijst has no values for cars older than this. */
export const KOERSLIJST_MAX_AGE_YEARS = 15

/**
 * Whether the ANWB Koerslijst can value this car: first admitted no more than fifteen years ago.
 *
 * The link is only shown when it can work. Sending a reader with an older car to a tool that then
 * has no value for it is a dead end the report would be leading them into. The first admission is
 * the age the market prices on; the construction year stands in only when the RDW has no admission
 * date, and with neither the answer is no rather than a guess.
 */
export function isValuedByKoerslijst(registration: RegistrationDetails, now: Date = new Date()): boolean {
  // Whole calendar dates, compared as text: a timestamp comparison would drop a car on the day it
  // turns fifteen, since the admission date parses as midnight UTC.
  const admitted = /^(\d{4})-(\d{2}-\d{2})/.exec(registration.firstAdmission ?? '')

  if (admitted) {
    const limit = `${Number(admitted[1]) + KOERSLIJST_MAX_AGE_YEARS}-${admitted[2]}`
    return limit >= localDate(now)
  }

  if (registration.constructionYear !== undefined) {
    return now.getFullYear() - registration.constructionYear <= KOERSLIJST_MAX_AGE_YEARS
  }

  return false
}

function localDate(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}
